import { useOfflineStatus } from '../hooks/useOfflineStatus';
import { WifiOff, Wifi, RefreshCw } from 'lucide-react';

const OfflineIndicator = () => {
  const { isOnline, clearCache } = useOfflineStatus();

  if (isOnline) return null;

  return (
    <div
      data-testid="offline-indicator"
      className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-lg"
    >
      <WifiOff className="w-4 h-4" />
      <span>You're offline. Showing cached data.</span>
      <button
        onClick={() => {
          clearCache();
          window.location.reload();
        }}
        className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-xs transition-colors"
        data-testid="offline-retry-btn"
      >
        <RefreshCw className="w-3 h-3" />
        Retry
      </button>
    </div>
  );
};

export default OfflineIndicator;
